import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { apiService } from '../../services/api';

interface SuperuserRouteProps {
  children: React.ReactNode;
}

const SuperuserRoute: React.FC<SuperuserRouteProps> = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    const check = async () => {
      try {
        const user = await apiService.getCurrentUser();
        setAllowed(Boolean(user?.is_superuser));
      } catch (err) {
        setAllowed(false);
      } finally {
        setLoading(false);
      }
    };
    check();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen text-slate-900 bg-slate-50 font-sans">
        <div className="max-w-3xl mx-auto px-4 py-12">
          <div className="bg-white rounded-2xl shadow-card border border-gray-100 p-8 text-center">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600 mx-auto"></div>
            <p className="mt-4 text-sm text-slate-500">Checking permissions…</p>
          </div>
        </div>
      </div>
    );
  }

  if (!allowed) {
    return <Navigate to="/newsfeed" replace />;
  }

  return <>{children}</>;
};

export default SuperuserRoute;
